import _extends from "@babel/runtime/helpers/extends";
import React, { memo, useEffect } from 'react';
import { SnackbarProvider, useSnackbar } from 'notistack';
import { proxy } from 'valtio';
import CloseIcon from '@material-ui/icons/Close';
import useStyles from './styles';
import Button from '../Button';
var initObject = {
  show: function show() {
    console.error('You need add snackbar to root, before use this function');
    return '';
  },
  close: function close() {
    console.error('You need add snackbar to root, before use this function');
  }
};
var snackbarControl = proxy(initObject);

var Control = function () {
  var _useSnackbar = useSnackbar(),
      enqueueSnackbar = _useSnackbar.enqueueSnackbar,
      closeSnackbar = _useSnackbar.closeSnackbar;

  useEffect(function () {
    snackbarControl.show = enqueueSnackbar;
    snackbarControl.close = closeSnackbar;
    return function () {
      snackbarControl = initObject;
    };
  }, []);
  return null;
};

export var showSnackbarVariant = function (variant) {
  return function (message, options) {
    var autoHideDuration;

    if (typeof message === 'string') {
      autoHideDuration = Math.min(Math.max((message == null ? void 0 : message.length) * 50, 2000), 10000);
    }

    return snackbarControl.show(message, _extends({
      // @ts-ignore
      variant: variant,
      autoHideDuration: autoHideDuration
    }, options));
  };
};
export var showSnackbar = showSnackbarVariant('default');
export var closeSnackbar = function (key) {
  return snackbarControl.close(key);
};
export var showSuccessSnackbar = showSnackbarVariant('success');
export var showErrorSnackbar = showSnackbarVariant('error');
export var showWarningSnackbar = showSnackbarVariant('warning');
export var showInfoSnackbar = showSnackbarVariant('info');
export var showPrimarySnackbar = showSnackbarVariant('primary');

var Provider = function (props) {
  var classes = useStyles(props);
  return /*#__PURE__*/React.createElement(SnackbarProvider, _extends({
    classes: {
      variantSuccess: classes.success,
      variantError: classes.danger,
      variantWarning: classes.warning,
      variantInfo: classes.info
    },
    maxSnack: 5,
    action: function action(key) {
      return /*#__PURE__*/React.createElement(Button, {
        onClick: function onClick() {
          return closeSnackbar(key);
        },
        justIcon: true,
        simple: true,
        color: "transparent"
      }, /*#__PURE__*/React.createElement(CloseIcon, null));
    },
    anchorOrigin: {
      vertical: 'top',
      horizontal: 'right'
    }
  }, props), /*#__PURE__*/React.createElement(Control, null));
};

export default /*#__PURE__*/memo(Provider);